import React from 'react'

import styles from "./CodeBox.module.scss";
export default function CodeBox({code}:{code?: string}) {
  return (
    <div className={[styles["paygo-code"]].join(" ")}>
      <span>{formatCode(code, ' - ')}</span>
    </div>
  )
}

const formatCode = (code?: string, separator: string = ' ') => {
    if (!code) return '';
    return code.split('').reduce((acc, char, index) => {
      return acc + (index > 0 && index % 5 === 0 ? (separator): '') + char;
    }, '');
  };